"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardComponent = void 0;
require("rxjs");
const $ = require("jquery");
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const events_1 = require("./events");
const product_service_1 = require("./product.service");
const auth_guard_service_1 = require("./auth-guard.service");
const bid_data_filter_service_1 = require("./bid-data-filter.service");
const bid_data_service_1 = require("./bid-data.service");
const boolean_key_pipe_1 = require("./boolean-key.pipe");
const branding_service_1 = require("./branding.service");
const clients_service_1 = require("./clients.service");
const dashboard_report_service_1 = require("./dashboard-report.service");
const data_metric_service_1 = require("./data-metric.service");
const data_source_service_1 = require("./data-source.service");
const angular2_moment_1 = require("angular2-moment");
//EXTERNAL LIBRARY BITS
const ng2_daterangepicker_1 = require("ng2-daterangepicker");
const demand_partner_service_1 = require("./demand-partner.service");
const loading_service_1 = require("./loading.service");
const notification_service_1 = require("./notification.service");
const optional_search_with_array_pipe_1 = require("./optional-search-with-array.pipe");
const permission_service_1 = require("./permission.service");
const router_1 = require("@angular/router");
const search_custom_pipe_1 = require("./search-custom.pipe");
const size_service_1 = require("./size.service");
const platform_browser_1 = require("@angular/platform-browser");
//INTERNAL LIBRARY BITS
const token_service_1 = require("./token.service");
const user_service_1 = require("./user.service");
let DashboardComponent = class DashboardComponent {
    j(i) {
        return JSON.stringify(i);
    }
    constructor(_http, _router, _datePipe, _bidData, _bidDataFilter, _size, _demandPartner, _loading, _title, _searchCustom, _booleanKey, _optionalSearchWithArray, _clients, _permission, _authguard, _branding, _talk, _user, _report, _dataSource, _product, _dataMetric) {
        this._http = _http;
        this._router = _router;
        this._datePipe = _datePipe;
        this._bidData = _bidData;
        this._bidDataFilter = _bidDataFilter;
        this._size = _size;
        this._demandPartner = _demandPartner;
        this._loading = _loading;
        this._title = _title;
        this._searchCustom = _searchCustom;
        this._booleanKey = _booleanKey;
        this._optionalSearchWithArray = _optionalSearchWithArray;
        this._clients = _clients;
        this._permission = _permission;
        this._authguard = _authguard;
        this._branding = _branding;
        this._talk = _talk;
        this._user = _user;
        this._report = _report;
        this._dataSource = _dataSource;
        this._product = _product;
        this._dataMetric = _dataMetric;
        //initializations
        this.dataSource = this._dataSource.getCurrentSource();
        this.sortMod = true;
        this.validDemandPartners = [];
        this.curve = d3.curveMonotoneX;
        this.minDate = new Date();
        this.dateRangeOptions = {};
        this.savingReport = false;
        this.savingReportLoad = false;
        this.dateRangeSelected = "Last 7 Days";
        this.showMenu = false;
        this.saveReport = false;
        this.focusReportName = new core_1.EventEmitter();
        this.overviewGraphDisplay = true;
        this.dataDisplay = true;
        this.dataMetrics = [];
        this.showMetricMenu = false;
        this.stringDataMetrics = ["adunitcode", "bidder", "domain"];
        this.showExportOpts = false;
        this.itemsPerPage = 20;
        this.adUnitsFilterMapping = {
            dataMethod: "getBiddersAdunitsMapping",
            groupBy: "adUnits",
            dataKey: "bidders",
        };
        this.visibleGroupingMetrics = {};
        this.displayDatePicker = false;
        this.filterLoading = {
            deals: false,
        };
        // line, area
        this.autoScale = true;
        /**
         *
         * @param picker
         * @returns
         * This method is to set the picker's end date time based on calender hour and minute dropdown if custom range is selected
         * This is to override picker's default behaviour of reseting hour to 00 on date change via input to update the picker's time based on value visible in hour and minute dropdown
         */
        this.getPickerEndDate = (picker) => {
            if (picker.chosenLabel === "Custom Range") {
                const _hour = $(".calendar.right .hourselect").val();
                const _min = $(".calendar.right .minuteselect").val();
                return moment(picker.endDate.set({
                    hour: _hour,
                    minute: _min,
                    second: 0,
                    millisecond: 0,
                }));
            }
            return moment(picker.endDate).startOf("hour");
        };
        /**
         *
         * @param picker
         * @returns
         * This method is to set the picker's start date time based on calender hour and minute dropdown if custom range is selected
         * This is to override picker's default behaviour of reseting hour to 00 on date change via input to update the picker's time based on value visible in hour and minute dropdown
         */
        this.getPickerStartDate = (picker) => {
            if (picker.chosenLabel === "Custom Range") {
                const _hour = $(".calendar.left .hourselect").val();
                const _min = $(".calendar.left .minuteselect").val();
                return moment(picker.startDate.set({
                    hour: _hour,
                    minute: _min,
                    second: 0,
                    millisecond: 0,
                }));
            }
            return moment(picker.startDate).startOf("hour");
        };
        this._title.setTitle(this._branding.getDashboardTitle());
        // this.sortList = 'dfp_revenue';
        Promise.resolve(this._bidData.getColorScheme()).then((colorScheme) => {
            this.colorScheme = colorScheme;
            this.revenueColor = colorScheme.domain[0];
            this.adRendersColor = colorScheme.domain[1];
            this.adRendersECPM = colorScheme.domain[2];
        });
    }
    ngOnInit() {
        this.initEvents();
        this.initDashboard();
        this.initDateInputKeyDownEvent();
    }
    initDateInputKeyDownEvent() {
        let _startHour = "0";
        let _endHour = "0";
        let _isHourChanged = false;
        $("body").on("mouseover", "[name='daterangepicker_start'], [name='daterangepicker_end'], .calendar.left .hourselect, .calendar.right .hourselect", (e) => {
            _startHour = $(".calendar.left .hourselect").val();
            _endHour = $(".calendar.right .hourselect").val();
        });
        // $("body")
        // .on('mouseover', "[name='daterangepicker_end']", () => {
        // 	_startHour = $('.calendar.left .hourselect').val()
        // 	_endHour = $('.calendar.right .hourselect').val()
        // })
        // $("body")
        // .on('mouseover', ".calendar.left .hourselect", () => {
        // 	_startHour = $('.calendar.left .hourselect').val()
        // 	_endHour = $('.calendar.right .hourselect').val()
        // })
        // $("body")
        // .on('mouseover', ".calendar.right .hourselect", () => {
        // 	_startHour = $('.calendar.left .hourselect').val()
        // 	_endHour = $('.calendar.right .hourselect').val()
        // })
        $("body").on("focus keydown blur", "[name='daterangepicker_start'], [name='daterangepicker_end']", () => {
            _isHourChanged = true;
            this.setPickerDate(_startHour, _endHour);
        });
        // $("body")
        // .on('focus keydown blur', "[name='daterangepicker_end']", () => {
        // 	this.setPickerDate(_startHour, _endHour)
        // })
        $("body").on("blur", ".calendar.right .hourselect", (e) => {
            _endHour = e.target.value;
            _isHourChanged = true;
            this.setPickerDate(_startHour, _endHour);
        });
        $("body").on("blur", ".calendar.left .hourselect", (e) => {
            _startHour = e.target.value;
            _isHourChanged = true;
            this.setPickerDate(_startHour, _endHour);
        });
        $("body").on("mouseover", "li[data-range-key='Custom Range']", (e) => {
            if (_isHourChanged) {
                this.setPickerDate(_startHour, _endHour);
            }
        });
        $("body").on("click", "button[name='daterangeInput']", (e) => {
            _isHourChanged = false;
            this.setPickerDate(`${moment(this.picker.datePicker.startDate).hour()}`, `${moment(this.picker.datePicker.endDate).hour()}`);
        });
    }
    setPickerDate(startHour, endHour) {
        $(".calendar.right .hourselect").val(endHour);
        $(".calendar.left .hourselect").val(startHour);
    }
    ngAfterViewInit() {
        this.setDateRangePickerTime();
    }
    initEvents() {
        this.events = new events_1.DashboardEvents({
            user: this._user.get().id,
        });
    }
    showAsProduct() {
        return (this.permission &&
            this.permission["dashboard-data_source-show-as-product"]);
    }
    getDataSourceDropdownName({ showAsProduct }) {
        return showAsProduct ? "Product" : "Data Source";
    }
    reloadDealsFilter($event) {
        return __awaiter(this, void 0, void 0, function* () {
            this._bidDataFilter.clearFilterLocalData("deal_id", "deals");
            this.filterLoading.deals = true;
            yield this.wait(500);
            this.filterLoading.deals = false;
        });
    }
    wait(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
    }
    initDashboard() {
        this.dataSources = this._dataSource.getDashboardDisplaySource();
        this.permission = this._permission.get();
        this.showAllDomains = this._bidDataFilter.getShowAllDomains();
        this.clientAssociatedDomains = this._clients.getClientAssociatedDomains();
        this.dateRange = this._bidDataFilter.getDateRange();
        this.menuDateRange = this._bidDataFilter.getDateRangeName();
        this.dateRanges = this._bidDataFilter.getDateRanges();
        this.menuInterval = this._bidDataFilter.getInterval();
        this.intervals = this._bidDataFilter.getIntervals();
        this.dataSource = this._bidDataFilter.getDataSource();
        this.validDemandPartners = this._demandPartner.getValidDemandPartnersCodes(this.dataSource.slug);
        this._title.setTitle(this._branding.getDashboardTitle());
        this.cumulativeView = this._bidDataFilter.getCumulative();
        this.searchDomains = this._bidDataFilter.getSearchDomains();
        this.searchAdUnits = this._bidDataFilter.getSearchAdUnits();
        this.searchSizes = this._bidDataFilter.getSearchSizes();
        this.searchPublishers = this._bidDataFilter.getSearchPublishers();
        this.searchDemandPartners = this._bidDataFilter.getSearchDemandPartners();
        this.searchDeals = this._bidDataFilter.getSearchDeals();
        this.filterBidders = this._bidDataFilter.getFilterBidders();
        this.groupFilters = this._bidDataFilter.getGroupBy();
        this.totalBidData = this._bidData.getTotalBidData();
        this.cumulativeView = this._bidDataFilter.getCumulative();
        if (this._bidDataFilter.getDateRangeName())
            this.dateRangeSelected = this._bidDataFilter.getDateRangeName();
        else {
            this.dateRangeSelected = "Last 7 Days";
        }
        this.dataMetrics = this._dataMetric
            .getNonGroupingMetrics()
            .filter((metric) => !this.isHelmChecked() ? metric.slug.indexOf("helm") === -1 : metric);
        this.reports = this._user.getReports();
        this.bidData = this._bidData.getBidData();
        // get the grouping values that are based on the return bidData
        this.groupingDataMetrics = this._dataMetric.filterMetricsThatExistOn(this._dataMetric.getGroupingMetrics(), this.bidData[0]);
        this.groupingDataMetricsAux = this._dataMetric.filterMetricsThatExistOn(this._dataMetric.getGroupingMetricsAux(), this.bidData[0]);
        this.sortList = this.sortColumn();
        if (this._bidDataFilter.getQParams()) {
            this.events.add({
                subFeature: events_1.EventSubFeature.report,
                context: "page-count",
                subject: this.pageCount(),
            });
        }
        this.currentDataSource = this._dataSource.getCurrentSource();
        this.dateRangeOptions = this._bidDataFilter.getDateRangeOptions();
        Promise.resolve(this._bidData.getChartData()).then((chartData = []) => {
            if (!chartData.length)
                return;
            this.chartData = chartData;
            /*
             * Need to normalize the data across a 0-100 spectrum
             */
            var timeFormat, interval = this.menuInterval.toLowerCase();
            if (this.chartData[0] && this.chartData[0].series[0]) {
                switch (true) {
                    case interval == "hourly":
                        timeFormat = "MM/DD ha";
                        break;
                    case interval == "yearly":
                        timeFormat = "MM/DD/YY";
                        break;
                    case moment(this.chartData[0].series[0].name).format("YYYY") !=
                        moment(this.chartData[0].series[this.chartData[0].series.length - 1].name)
                            .format("YYYY"):
                        timeFormat = "MM/DD/YY";
                        break;
                    default:
                        timeFormat = "MM/DD";
                        break;
                }
                //			this.dateEntries = this.chartData[0].series.map(function(item) {
                //				return moment(item.name).format(timeFormat);
                //			});
                this.dateEntries = [
                    moment(this.chartData[0].series[0].name).format(timeFormat),
                    moment(this.chartData[0].series[this.chartData[0].series.length - 1].name)
                        .format(timeFormat),
                ];
                var vals = [];
                for (let i in this.chartData) {
                    // loop the chartData and map the series values
                    vals = this.chartData[i].series.map(function (item) {
                        return item.value;
                    });
                    // create a yScale
                    var yScale = d3
                        .scaleLinear()
                        .domain([d3.min(vals), d3.max(vals)])
                        .range([0, 100]);
                    // reset the values
                    for (let j in this.chartData[i].series) {
                        this.chartData[i].series[j].rawValue =
                            this.chartData[i].series[j].value;
                        this.chartData[i].series[j].value = yScale(this.chartData[i].series[j].value);
                        this.chartData[i].series[j].name = moment(this.chartData[i].series[j].name)
                            .format("MM/DD/YY h:mm:ss a"); // Note: tz_datehour is already in user timezone
                    }
                    // @todo: need the tooltip to display realValue
                }
            }
        });
    }
    pageCount() {
        return Math.ceil(this.bidData.length / this.itemsPerPage);
    }
    getInterval() {
        return this._bidDataFilter.getInterval();
    }
    groupingMetricsCount() {
        return this.groupingDataMetricsAux.length;
    }
    bidDataColCount() {
        let count = 0;
        let rawrow = this.bidData.length > 1 ? this.bidData[1] : this.bidData[0];
        if (typeof rawrow.tz_datehour != "undefined")
            count++;
        if (typeof rawrow.adunitcode != "undefined")
            count++;
        if (typeof rawrow.size != "undefined")
            count++;
        if (typeof rawrow.bidder != "undefined")
            count++;
        if (typeof rawrow.domain != "undefined")
            count++;
        if (typeof rawrow.client_id != "undefined")
            count++;
        if (typeof rawrow.organization_id != "undefined")
            count++;
        if (typeof rawrow.deal_id != "undefined")
            count++;
        if (typeof rawrow.deal_type != "undefined")
            count++;
        return count;
    }
    biddersCollapse() {
        for (var i = 0; i < this.bidders.length; i++) {
            this.bidders[i].collapsed = true;
        }
    }
    biddersExpand() {
        for (var i = 0; i < this.bidders.length; i++) {
            this.bidders[i].collapsed = false;
        }
    }
    sortSign() {
        if (this.sortMod) {
            return "-";
        }
        else {
            return "+";
        }
    }
    sortColumn() {
        if (this.groupingMetricsHasDate()) {
            return "tz_datehour";
        }
        return this.cumulativeView ? "dfp_revenue" : "tz_datehour";
    }
    groupingMetricsHasDate() {
        return !!this.groupingDataMetrics.find((metric) => {
            return metric.slug === "tz_datehour";
        });
    }
    onSelect(event) {
        console.log(event);
    }
    sort(sortBy) {
        if (this.sortList == sortBy) {
            this.sortMod = !this.sortMod;
        }
        else {
            this._bidDataFilter.setSort(sortBy);
            this.sortList = sortBy;
            if (this.stringDataMetrics.indexOf(sortBy) > -1) {
                this.sortMod = false;
            }
            else {
                this.sortMod = true;
            }
        }
    }
    getRenders() {
        return this.totalBidData.renders || this.totalBidData.adjusted_renders;
    }
    getRevenue() {
        return (this.totalBidData.dfp_revenue || this.totalBidData.adjusted_dfp_revenue);
    }
    getECPM() {
        return this.totalBidData.ecpm || this.totalBidData.adjusted_ecpm;
    }
    getRevenueTitle() {
        return `Revenue${this.showBillingDisclaimer() ? "*" : ""}`;
    }
    getAdRendersTitle() {
        return `Ad Renders${this.showBillingDisclaimer() ? "*" : ""}`;
    }
    getECPMTitle() {
        return `eCPM${this.showBillingDisclaimer() ? "*" : ""}`;
    }
    showBillingDisclaimer() {
        return this._branding.showBillingDisclaimer();
    }
    getTooltip(dataMetric) {
        return (this.permission["dashboard-view-tooltip--all"] &&
            !this.currentDataSource.isConnect()) ||
            this.permission[`dashboard-view-tooltip--${dataMetric.slug}`]
            ? dataMetric.tooltip
            : "";
    }
    stopAutoclose(event) {
        event.stopPropagation();
    }
    switchCumulative() {
        this._bidDataFilter.setCumulative(!this.cumulativeView);
        this.cumulativeView = this._bidDataFilter.getCumulative();
    }
    isHelmChecked() {
        return this._bidDataFilter.isHelmChecked();
    }
    toggleHelmChecked() {
        this._bidDataFilter.toggleHelmChecked();
    }
    switchDataSource(ds) {
        this.dataSource = ds;
        this._bidDataFilter.setDataSource(ds);
        this._bidDataFilter.clearGrouping();
        this._bidDataFilter.clearHelmChecked();
        this.dateRangeOptions = this._bidDataFilter.getDateRangeOptions();
        // Reset the date filter
        this._bidDataFilter.setFallbackTime();
        this.dateRange = this._bidDataFilter.getDateRange();
        this.dateRangeSelected = this._bidDataFilter.getDateRangeName();
        // need to reset date times and defer to update after current calls stack,
        //since the datapicker package, will be rerendered whenever the dateRangeOptions are changed;
        setTimeout(() => this.setDateRangePickerTime());
        this.intervals = this._bidDataFilter.getIntervals();
    }
    switchGroupBy(filter) {
        //this gets sent a string like 'domains'
        this._bidDataFilter.setGroupBy(filter);
        let enabled = this._bidDataFilter.getGroupBy()[filter];
        this.events.add({
            subFeature: events_1.EventSubFeature.filter,
            context: filter,
            subject: filter,
            action: enabled ? events_1.EventAction.enabled : events_1.EventAction.disabled,
        });
    }
    toggleGroupingToShow() {
        this.filterBidders = !this.filterBidders;
        let filter = "grouping-to-show";
        this.events.add({
            subFeature: events_1.EventSubFeature.filter,
            context: filter,
            action: events_1.EventAction.toggled,
            subject: this.filterBidders ? "bidders" : "ad-units",
        });
    }
    //FILTER LOGIC AND FUNCTIONS
    adUnitBidderMenuOptions(menuOptionArray) {
        let len = this._booleanKey.transform(menuOptionArray, true, "selected").length;
        if (len == menuOptionArray.length) {
            this.noneMenuOptions(menuOptionArray, "");
        }
        else {
            this.allMenuOptions(menuOptionArray, "");
        }
    }
    allMenuOptions(menuOptionArray, search) {
        let q = this._searchCustom.transform(menuOptionArray, search, [
            "displayName",
        ]);
        for (let mO = 0; mO < q.length; mO++) {
            q[mO].selected = true;
        }
    }
    noneMenuOptions(menuOptionArray, search) {
        let q = this._searchCustom.transform(menuOptionArray, search, [
            "displayName",
        ]);
        for (let mO = 0; mO < q.length; mO++) {
            q[mO].selected = false;
        }
    }
    toJSON(a) {
        return JSON.stringify(a);
    }
    setMenuRange(e) {
        this.dateRange.start = e.picker
            ? this.getPickerStartDate(e.picker)
            : moment(e.start).startOf("hour");
        this.dateRange.end = e.picker
            ? this.getPickerEndDate(e.picker)
            : moment(e.end).startOf("hour");
        this.dateRange.name = e.picker.chosenLabel;
        this.dateRangeSelected = this.dateRange.name;
        /* @todo: need to check if commenting this cause any advers effect, as it doesnt seems required */
        // this.picker.options.maxDate = moment(this.dateRange.end).endOf('d').startOf('h'); //Work around, end date gets stuck unless max date forces change
        // this.picker.datePicker.setStartDate(moment(this.dateRange.start).startOf('h'));
        // this.picker.datePicker.setEndDate(moment(this.dateRange.end).startOf('h'));
        // this.picker.options.maxDate = this._bidDataFilter.defaultMaxDateRange();
        Promise.resolve(this._bidDataFilter.setDateRange(this.dateRange)).then((err) => {
            Promise.resolve((this.dateRange = this._bidDataFilter.setDateRangeByName(this.dateRange.name))).then((res) => {
                this.intervals = this._bidDataFilter.getIntervals();
                this.events.add({
                    subFeature: events_1.EventSubFeature.filter,
                    context: this.withClockOptionsSet() ? "date-with-clock" : "date",
                    subject: this.dateRange.name,
                    action: events_1.EventAction.changed,
                });
            });
        });
    }
    withClockOptionsSet() {
        return (moment(this.dateRange.start).format("hh:mm:ss a") !== "12:00:00 am" &&
            moment(this.dateRange.end).format("hh:mm:ss a") !== "11:00:00 pm");
    }
    setDateRangePickerTime() {
        this.picker.datePicker.setStartDate(moment(this.dateRange.start).startOf("h"));
        this.picker.datePicker.setEndDate(moment(this.dateRange.end).startOf("h"));
    }
    getDateRange() {
        return (moment(this.dateRange.start).format("MM/DD/YYYY HH:mm") +
            " - " +
            moment(this.dateRange.end).format("MM/DD/YYYY HH:mm"));
    }
    selectInterval(menuOption) {
        this._bidDataFilter.setInterval(menuOption.displayName);
        this._bidDataFilter.setCumulative(false);
        this.cumulativeView = false;
        this.events.add({
            subFeature: events_1.EventSubFeature.filter,
            context: "interval",
            subject: menuOption.displayName,
            action: events_1.EventAction.changed,
        });
    }
    resetFilters(pull) {
        this._bidDataFilter.resetAllFilters();
        if (pull)
            this.requestNewBidData();
    }
    requestNewBidData() {
        this._loading.start("Fetching Data...");
        this.sortList = this.sortColumn();
        this._bidDataFilter.setSort(this.sortList);
        this._bidDataFilter.setShowAllDomains(this.showAllDomains);
        if (this.searchPublishers.length > 0)
            this._bidDataFilter.setSearchPublishers(this.searchPublishers);
        if (this.searchDomains.length > 0)
            this._bidDataFilter.setSearchDomains(this.searchDomains);
        if (this.searchAdUnits.length > 0)
            this._bidDataFilter.setSearchAdUnits(this.searchAdUnits);
        if (this.searchSizes.length > 0)
            this._bidDataFilter.setSearchSizes(this.searchSizes);
        if (this.searchDemandPartners.length > 0)
            this._bidDataFilter.setSearchDemandPartners(this.searchDemandPartners);
        if (this.searchDeals.length > 0)
            this._bidDataFilter.setSearchDeals(this.searchDeals);
        this._router.navigate(["/refresh"]);
        this._bidDataFilter.setQParams();
        this._bidData
            .pull()
            .then((res) => {
            this.events.batchCreate();
            const asyncForNewBidData = () => __awaiter(this, void 0, void 0, function* () {
                yield this._router.navigate(["/dashboard/main"], {
                    queryParams: this._bidDataFilter.getParsedQParams(),
                });
                this._loading.stop();
            });
            asyncForNewBidData();
        })
            .catch((err) => {
            this._bidData.handleBidDataRequestError(err, true, "Oops! We had a problem requesting new bid data. Please try again.");
            this._bidData.setBidData([]);
            this._bidData.setHasHadData(false);
            this._loading.stop();
        });
    }
    handleExportError(err) {
        this._bidData.handleBidDataRequestError(err, false, "Oops! We had an internal error exporting this data. Please try again");
    }
    focusOnReportName() {
        this.focusReportName.emit(true);
    }
    openReport(report) {
        this.reportPage = 1;
        this._report
            .openReport(report)
            .then((err) => {
            this.initDashboard();
        })
            .catch((err) => {
            this._bidData.handleBidDataRequestError(err, true, "Oops! We had a problem requesting new bid data. Please try again.");
        });
    }
    savingReportKeypress(event) {
        if (event.keyCode == 13) {
            this.saveNewReport();
        }
    }
    saveNewReport() {
        //trim report name to avoid save call on blank or only space in report name
        let trimmedReportName = this.newReportName.trim();
        this.savingReportLoad = true;
        if (trimmedReportName && trimmedReportName != "") {
            this._bidDataFilter.setQParams().then((err) => {
                let qP = {};
                Promise.resolve((qP = this._bidDataFilter.getQParams())).then((err) => {
                    console.log(qP);
                    this._report
                        .saveUserReport({
                        displayName: this.newReportName,
                        queryParams: qP,
                        lastViewed: moment().utc(),
                        dataSource: this.currentDataSource.id,
                    })
                        .then((err) => {
                        this.reports = this._user.getReports();
                        this.savingReportLoad = false;
                        this.savingReport = false;
                        this.newReportName = "";
                    });
                });
            });
        }
        else {
            this._talk.broadcast("Your new report needs a name to save");
            this.savingReportLoad = false;
            this.savingReport = false;
        }
    }
    currentReport(report) {
        return false;
    }
    deleteReport(report) {
        this._report.deleteUserReport(report).then((err) => {
            this.reports = this._user.getReports();
        });
    }
    adServerColCount() {
        if (this.dataMetrics && this.dataMetrics.length > 0)
            return this.dataMetrics.filter((val) => {
                return val.visible && val.dataType == "adServer";
            }).length;
        else
            return 0;
    }
    biddr360ColCount() {
        if (this.dataMetrics && this.dataMetrics.length > 0)
            return this.dataMetrics.filter((val) => {
                return val.visible && val.dataType == "biddr360Data";
            }).length;
        else
            return 0;
    }
    changePage($event) {
        this.listPage = $event;
        this.events.add({
            subFeature: events_1.EventSubFeature.report,
            context: "pagination",
            action: events_1.EventAction.paginate,
            subject: this.listPage,
        });
    }
    metricToggled(dataMetric) {
        this.events.add({
            subFeature: events_1.EventSubFeature.report,
            context: "metric",
            action: events_1.EventAction.toggled,
            subject: dataMetric.displayName,
        });
    }
    toggleOverview() {
        this.overviewGraphDisplay = !this.overviewGraphDisplay;
        this.events.add({
            subFeature: events_1.EventSubFeature.report,
            context: "overview",
            action: events_1.EventAction.toggled,
            subject: "overview",
        });
    }
    toggleData() {
        this.dataDisplay = !this.dataDisplay;
        this.events.add({
            subFeature: events_1.EventSubFeature.report,
            context: "data",
            action: events_1.EventAction.toggled,
            subject: "data",
        });
    }
    toggleDatePicker() {
        this.displayDatePicker = !this.displayDatePicker;
        // Currently we manually trigger hide and show element
        // since the ng2-daterangepicker wrapper does not expose access to the 'toggle'
        // method available in the native datepicker module bootstrap-daterangepicker
        if (this.displayDatePicker) {
            this.picker.datePicker.setStartDate(moment(this.dateRange.start));
            this.picker.datePicker.setEndDate(moment(this.dateRange.end));
            $(".daterangepicker").show();
        }
        else {
            $(".daterangepicker").hide();
        }
    }
    getRowClass(metric) {
        let classes = [];
        // Data conditions
        if (this._dataMetric.isAdServer(metric) &&
            this.currentDataSource.isClientSide()) {
            classes.push("table--header--heading__adServerData");
        }
        else if (this._dataMetric.isBiddr360(metric) &&
            this.currentDataSource.isClientSide()) {
            classes.push("table--header--heading__biddr360Data");
        }
        else if (this.currentDataSource.isServerSideOrDealsOrConnect()) {
            classes.push("table--header--heading__rtbxData");
        }
        // Sort mod
        classes = classes.concat(this.getActiveFilterClass(metric));
        return classes;
    }
    getActiveFilterClass(metric) {
        return metric.slug === this.sortList && !this.sortMod
            ? ["activeFilterUp"]
            : metric.slug === this.sortList && this.sortMod
                ? ["activeFilterDown"]
                : [];
    }
    canViewGroupByIntegrationsFilter(source, filterKey) {
        return (this.canViewGroupByFilter(source, filterKey) &&
            this.permission["system-branding--biddr_connect"]);
    }
    canToggleHelm() {
        return this._bidDataFilter.canToggleHelm();
    }
    canViewGroupByFilter(source, filterKey) {
        return this.dataSource.slug.includes(source)
            ? this._bidDataFilter.canGroupBy(filterKey, this.permission)
            : false;
    }
    canViewGroupByOrganization(source, filterKey) {
        let canViewGroupBy = this.canViewGroupByFilter(source, filterKey);
        let hasAllOrgs = this.permission["admin-organizations--view_all"];
        let hasRestrictedOrgs = this.permission["admin-organizations--view_available_list"];
        let hasMoreThanOneManagedOrg = this._user.get().managedOrganizationCount() > 1;
        return (canViewGroupBy &&
            (hasAllOrgs || (hasRestrictedOrgs && hasMoreThanOneManagedOrg)));
    }
    formatMetric(value, metricConfig) {
        return this._dataMetric.formatMetricValue(value, metricConfig, true);
    }
    trackMetricBy(idx, metric) {
        return metric ? metric.id : undefined;
    }
    getNoDataMessage() {
        const defaultMsg = "If you feel you are seeing this message in error, please contact your Account Manager.";
        if (this.currentDataSource.isClientSide()) {
            return `There is currently no data available to be shown on your Dashboard. 
  	  What this means is that you either have not yet launched your ${this._branding.getProductName()} File onto your site, 
  	  or your file has been live for less than 24 hours. ${defaultMsg}`;
        }
        return defaultMsg;
    }
};
exports.DashboardComponent = DashboardComponent;
__decorate([
    (0, core_1.ViewChild)(ng2_daterangepicker_1.DaterangePickerComponent),
    __metadata("design:type", ng2_daterangepicker_1.DaterangePickerComponent)
], DashboardComponent.prototype, "picker", void 0);
exports.DashboardComponent = DashboardComponent = __decorate([
    (0, core_1.Component)({
        selector: "my-dashboard",
        templateUrl: "app/dashboard.component.html",
        styleUrls: ["styles/dashboard.component.css"],
    }),
    __metadata("design:paramtypes", [token_service_1.TokenService,
        router_1.Router,
        angular2_moment_1.DateFormatPipe,
        bid_data_service_1.BidDataService,
        bid_data_filter_service_1.BidDataFilterService,
        size_service_1.SizeService,
        demand_partner_service_1.DemandPartnerService,
        loading_service_1.LoadingService,
        platform_browser_1.Title,
        search_custom_pipe_1.SearchCustomPipe,
        boolean_key_pipe_1.BooleanKeyPipe,
        optional_search_with_array_pipe_1.OptionalSearchWithArrayPipe,
        clients_service_1.ClientsService,
        permission_service_1.PermissionService,
        auth_guard_service_1.AuthGuard,
        branding_service_1.BrandingService,
        notification_service_1.NotificationService,
        user_service_1.UserService,
        dashboard_report_service_1.DashboardReportService,
        data_source_service_1.DataSourceService,
        product_service_1.ProductService,
        data_metric_service_1.DataMetricService])
], DashboardComponent);
//# sourceMappingURL=dashboard.component.js.map